import { TFunction } from 'i18next'

export const ORDER_STATUS_REFUNDED = -2
export const ORDER_STATUS_CANCELED = -1
export const ORDER_STATUS_INITIAL = 0
export const ORDER_STATUS_PLACED = 1
export const ORDER_STATUS_PAID = 2
export const ORDER_STATUS_WAITING_FOR_PAYMENT = 10
export const ORDER_STATUS_WAITING_FOR_POST_PAYMENT = 11
export const ORDER_STATUS_POST_PAYMENT_PAID = 12
export const ORDER_STATUS_ASSEMBLY_IN_PROGRESS = 5
export const ORDER_STATUS_ASSEMBLY_COMPLETE = 6
export const ORDER_STATUS_ACCEPTED_BY_COURIER = 4
export const ORDER_STATUS_WAITING_FOR_COURIER = 7
export const ORDER_STATUS_DELIVERY_IN_PROGRESS = 8
export const ORDER_STATUS_DELIVERED = 9
export const ORDER_STATUS_COMPLETED = 99
export const ORDER_STATUS_RECALL_CLIENT = 20
export const ORDER_STATUS_WAITING_FOR_SLOT_CHANGE = 21
export const ORDER_STATUS_SLOT_CHANGED = 22
export const ORDER_STATUS_WAITING_FOR_PICKUP = 30

export const ORDER_STATUS_IN_PROGRESS = [
  ORDER_STATUS_PLACED,
  ORDER_STATUS_PAID,
  ORDER_STATUS_WAITING_FOR_PAYMENT,
  ORDER_STATUS_ASSEMBLY_IN_PROGRESS,
  ORDER_STATUS_WAITING_FOR_POST_PAYMENT,
  ORDER_STATUS_ASSEMBLY_COMPLETE,
  ORDER_STATUS_ACCEPTED_BY_COURIER,
  ORDER_STATUS_WAITING_FOR_COURIER,
  ORDER_STATUS_DELIVERY_IN_PROGRESS,
  ORDER_STATUS_POST_PAYMENT_PAID,
  ORDER_STATUS_WAITING_FOR_PICKUP,
]

export const ORDER_STATUS_BEFORE_ASSEMBLE_START = [
  ORDER_STATUS_PLACED,
  ORDER_STATUS_CANCELED,
]

export const ORDER_PAYMENT_STATUS_ORDER_PAYMENT_UNKNOWN = -1
export const ORDER_PAYMENT_STATUS_ORDER_PAYMENT_ARRIVED = 0
export const ORDER_PAYMENT_STATUS_ORDER_PAYMENT_REJECTED = 1

export function getOrderStatusLabel (status: number, t: TFunction) {
  switch (status) {
  case ORDER_STATUS_REFUNDED:
    return { label: t('status.refunded'), color: 'red' }
  case ORDER_STATUS_CANCELED:
    return { label: t('status.canceled'), color: 'red' }
  case ORDER_STATUS_INITIAL:
    return { label: t('status.initial'), color: null }
  case ORDER_STATUS_PLACED:
    return { label: t('status.placed'), color: 'green' }
  case ORDER_STATUS_PAID:
    return { label: t('status.paid'), color: 'green' }
  case ORDER_STATUS_WAITING_FOR_PAYMENT:
    return { label: t('status.waiting_for_payment'), color: 'yellow' }
  case ORDER_STATUS_ASSEMBLY_IN_PROGRESS:
    return { label: t('status.assembly_in_progress'), color: 'violet' }
  case ORDER_STATUS_ASSEMBLY_COMPLETE:
    return { label: t('status.assembly_complete'), color: 'green' }
  case ORDER_STATUS_ACCEPTED_BY_COURIER:
    return { label: t('status.accepted_by_courier'), color: 'violet' }
  case ORDER_STATUS_WAITING_FOR_COURIER:
    return { label: t('status.waiting_for_courier'), color: 'violet' }
  case ORDER_STATUS_DELIVERY_IN_PROGRESS:
    return { label: t('status.delivery_in_progress'), color: 'violet' }
  case ORDER_STATUS_POST_PAYMENT_PAID:
    return { label: t('status.post_payment_paid'), color: 'violet' }
  case ORDER_STATUS_WAITING_FOR_POST_PAYMENT:
    return {
      label: t('status.waiting_for_post_payment'),
      color: 'violet',
    }
  case ORDER_STATUS_DELIVERED:
    return { label: t('status.delivered'), color: 'green' }
  case ORDER_STATUS_COMPLETED:
    return { label: t('status.completed'), color: 'green' }
  case ORDER_STATUS_RECALL_CLIENT:
    return { label: t('status.recall_client'), color: 'red' }
  case ORDER_STATUS_WAITING_FOR_SLOT_CHANGE:
    return { label: t('status.waiting_for_slot_change'), color: 'red' }
  case ORDER_STATUS_SLOT_CHANGED:
    return { label: t('status.slot_changed'), color: 'blue' }
  case ORDER_STATUS_WAITING_FOR_PICKUP:
    return { label: t('status.waiting_for_pickup'), color: 'green' }
  default:
    return {
      label: t('status.unknown', { status }),
      color: 'red',
    }
  }
}

export const getStepFromOrderStatus = (status: number) => {
  switch (status) {
  case ORDER_STATUS_PLACED:
    return 0
  case ORDER_STATUS_ASSEMBLY_IN_PROGRESS:
    return 1
  case ORDER_STATUS_ASSEMBLY_COMPLETE:
    return 1
  case ORDER_STATUS_ACCEPTED_BY_COURIER:
    return 2
  case ORDER_STATUS_WAITING_FOR_COURIER:
    return 2
  case ORDER_STATUS_DELIVERY_IN_PROGRESS:
    return 2
  case ORDER_STATUS_DELIVERED:
    return 3
  case ORDER_STATUS_COMPLETED:
    return 3
  default:
    return 0
  }
}

export const getOrderPaymentStatusLabel = (
  paymentStatus: number,
  t: TFunction,
) => {
  switch (paymentStatus) {
  case ORDER_PAYMENT_STATUS_ORDER_PAYMENT_UNKNOWN:
    return t('payment.unknown')
  case ORDER_PAYMENT_STATUS_ORDER_PAYMENT_ARRIVED:
    return t('payment.arrived')
  case ORDER_PAYMENT_STATUS_ORDER_PAYMENT_REJECTED:
    return t('payment.rejected')
  default:
    return t('payment.error')
  }
}

export const isOrderCancellable = (orderStatus: number) => {
  switch (orderStatus) {
  case ORDER_STATUS_PLACED:
    return true
  default:
    return false
  }
}

export const RECEIPT_TYPE_PREPAYMENT = 'prepayment'
export const RECEIPT_TYPE_FULLPAYMENT = 'fullpayment'
export const RECEIPT_TYPE_PREPAYMENT_REFUND = 'prepaymentrefund'
export const RECEIPT_TYPE_REFUND = 'refund'

export const formatOrderReceiptType = (receiptType: string, t: TFunction) => {
  switch (receiptType) {
  case RECEIPT_TYPE_PREPAYMENT:
    return { label: t('receipt.prepayment'), color: 'green' }
  case RECEIPT_TYPE_FULLPAYMENT:
    return { label: t('receipt.fullpayment'), color: 'green' }
  case RECEIPT_TYPE_PREPAYMENT_REFUND:
    return { label: t('receipt.prepaymentrefund'), color: 'violet' }
  case RECEIPT_TYPE_REFUND:
    return { label: t('receipt.refund'), color: 'red' }
  default:
    return {
      label: t('receipt.default'),
      color: 'red',
    }
  }
}
